import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { vernacularLanguageList } from '../../utils/constants';

const PostLanguage = ({ post }) => {
  const classes = useStyles();

  const getLangFromKey = (languageKey) => {
    if (!languageKey) return;
    const lang = vernacularLanguageList.filter(
      (languageList) => languageList.key === languageKey
    );
    return lang[0] && lang[0].value;
  };

  return post && post.postLanguage ? (
    <Box display="inline" className={classes.postLanguageSetting}>
      <Typography variant="caption">
        Language: {getLangFromKey(post.postLanguage)}
      </Typography>
    </Box>
  ) : (
    ''
  );
};

const useStyles = makeStyles((theme) => ({
  postLanguageSetting: {
    background: theme.palette.grey[800],
    color: theme.palette.text.primary,
    float: 'right',
    marginTop: theme.spacing(2),
    padding: theme.spacing(0, 2, 0.5, 2),
  },
}));

export default PostLanguage;
